import { graphql } from "react-apollo";
import { ADMIN_ROLES } from "../constants";
import CurrentUserQuery from "../queries/CurrentUser";

const withCurrentUser = (options = {}) => Component => {
  const mergedOptions = {
    name: "userData",
    props({ userData }) {
      if (userData && userData.currentUser) {
        return {
          userData: {
            ...userData,
            isAdminUser: ADMIN_ROLES.indexOf(userData.currentUser.role) > -1
          }
        };
      }

      return { userData };
    },
    ...options
  };

  const WithCurrentUser = graphql(CurrentUserQuery, mergedOptions)(Component);

  const wrappedComponentName =
    Component.displayName || Component.name || "Component";

  WithCurrentUser.displayName = `withCurrentUser(${wrappedComponentName})`;

  return WithCurrentUser;
};

export default withCurrentUser;



// WEBPACK FOOTER //
// ./src/hocs/withCurrentUser.js